module.exports = __webpack_public_path__ + "images/help/icon-twr56@2x-adf57a4481c48ca94d6dacb9eec83c0d.png";